import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { TituloReceberPagamentoModule } from '../pagamento';
import { TituloReceberSituacaoModule } from '../situacao';
import { FormaPagamentoSelectModule } from '../../forma-pagamento/select';
import { CondicaoPagamentoSelectModule } from '../../condicao-pagamento/select';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';
import { RepresentanteSharedModule } from '../../pessoa/representante/representante-shared.module';
import { LocalFaturamentoSelectModule } from '../../local-faturamento/select';
import { NotaCardsModule, NotaFormInsertModule } from '../../nota';

import { TituloReceberFormComponent } from './titulo-receber-form.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberPagamentoModule,
        TituloReceberSituacaoModule,
        FormaPagamentoSelectModule,
        CondicaoPagamentoSelectModule,
        ClienteTypeaheadSharedModule,
        RepresentanteSharedModule,
        LocalFaturamentoSelectModule,
        NotaCardsModule,
        NotaFormInsertModule
    ],
    declarations: [
        TituloReceberFormComponent
    ],
    exports: [
        TituloReceberFormComponent
    ]
})
export class TituloReceberFormModule { }
